// extracted by mini-css-extract-plugin
export default {"banner":"SzfQt4oS1lEFC7tMwnqX","bannerWide":"d0ozUYUWcq3UpXg0Psbd","bannerImage":"cHkCH7N9oJa1W2dT6jRw","bannerHeading":"DnPvqVBsHiJHTB_axbXU","bannerButton":"y7RjUbazTMB99rid9lSK"};